/**
 * Preferencias.tsx — Pagina /notificacoes/preferencias.
 *
 * Spec docs/notificacoes/IMPLEMENTATION_SPEC_V1V2.md §3.4 / §3.8.
 *
 * Padrao: Stack de 5 WidgetCards (espelha `pages/perfil/Perfil.tsx`).
 * Sem <Tabs>, sem <Title> — header vem do ROUTE_MAP via PageHeader.
 */
import { Button, Group, Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import { notifications } from '@mantine/notifications'
import { IconRestore } from '@tabler/icons-react'
import { useQueryClient } from '@tanstack/react-query'
import { notificationPreferencesApi } from '@/api/notification-preferences'
import { PreferenciasCanais } from './PreferenciasCanais'
import { PreferenciasPresets } from './PreferenciasPresets'
import { PreferenciasQuietHours } from './PreferenciasQuietHours'
import { PreferenciasPorSource } from './PreferenciasPorSource'
import { PreferenciasOverrides } from './PreferenciasOverrides'
import { PreferenciasPrivacidade } from './PreferenciasPrivacidade'
import { PreferenciasSom } from './PreferenciasSom'

export default function Preferencias() {
  const qc = useQueryClient()

  const onResetDefaults = () => {
    modals.openConfirmModal({
      title: 'Restaurar configurações padrão?',
      children: (
        <Text size="sm">
          Sua personalização será apagada. As subscriptions default (feed + email
          para todas as sources) serão re-seedadas atomicamente.
        </Text>
      ),
      confirmProps: { color: 'orange' },
      labels: { confirm: 'Restaurar', cancel: 'Cancelar' },
      onConfirm: async () => {
        try {
          const r = await notificationPreferencesApi.resetToDefaults()
          notifications.show({
            color: 'green',
            title: 'Padrões restaurados',
            message: `${r.deleted_count} apagadas, ${r.seeded_count} re-seedadas.`,
          })
          qc.invalidateQueries({
            predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === 'me',
          })
        } catch (e) {
          notifications.show({
            color: 'red',
            title: 'Erro',
            message: String((e as Error).message ?? e),
          })
        }
      },
    })
  }

  return (
    <Stack gap="lg">
      <Group justify="flex-end">
        <Button
          size="xs"
          variant="subtle"
          color="orange"
          leftSection={<IconRestore size={14} />}
          onClick={onResetDefaults}
        >
          Restaurar padrões
        </Button>
      </Group>
      <PreferenciasCanais />
      <PreferenciasSom />
      <PreferenciasPresets />
      <PreferenciasQuietHours />
      <PreferenciasPorSource />
      <PreferenciasOverrides />
      <PreferenciasPrivacidade />
    </Stack>
  )
}
